(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-christmas-landing"] && !Shopify.designMode) return;
  try {
    
  class MerchMakerChristmasFilters extends HTMLElement {
    connectedCallback() {
      if (this.__mmBound) return;
      this.__mmBound = true;

      this.grid = this.querySelector('[data-mm-grid]');
      this.empty = this.querySelector('[data-mm-empty]');
      this.prompt = this.querySelector('[data-mm-prompt]');
      this.countEl = this.querySelector('[data-mm-count]');
      this.resetButton = this.querySelector('[data-mm-filter-reset]');
      this.searchInput = this.querySelector('[data-mm-search]');
      this.brandSelect = this.querySelector('[data-mm-brand-filter]');

      // hasChosen: nothing is shown until the visitor makes a choice -
      // clicking a category/"Vis alle", a budsjett-chip, or typing a søk
      // all count. "Kan produktlisten være tom" ved første besøk.
      this.state = { category: '', min: null, max: null, search: '', brand: '', hasChosen: false };

      this.addEventListener('click', (event) => this.#onClick(event));
      this.addEventListener('change', (event) => this.#onChange(event));

      if (this.searchInput) {
        this.searchInput.addEventListener('input', () => {
          this.state.search = this.searchInput.value.trim().toLowerCase();
          this.state.hasChosen = true;
          this.#render();
        });
      }

      this.#applyFromURL();
      this.#updateBrandOptions();
      this.#render();
    }

    #onClick(event) {
      const categoryButton = event.target.closest('[data-mm-filter-category]');
      if (categoryButton) {
        this.#selectCategory(categoryButton);
        return;
      }

      const budgetButton = event.target.closest('[data-mm-filter-budget]');
      if (budgetButton) {
        this.#toggleBudget(budgetButton);
        return;
      }

      const resetButton = event.target.closest('[data-mm-filter-reset]');
      if (resetButton) {
        this.#reset();
      }
    }

    #onChange(event) {
      if (event.target === this.brandSelect) {
        this.state.brand = this.brandSelect.value;
        this.#render();
      }
    }

    #categoryButtons() {
      return Array.from(this.querySelectorAll('[data-mm-filter-category]'));
    }

    #budgetButtons() {
      return Array.from(this.querySelectorAll('[data-mm-filter-budget]'));
    }

    #tiles() {
      return Array.from(this.querySelectorAll('[data-mm-product-tile]'));
    }

    // Radio-style: clicking a category (or "Vis alle") always selects it
    // directly - no separate deselect-by-reclicking step.
    #selectCategory(button) {
      const value = (button.getAttribute('data-value') || '').toLowerCase();
      const changed = value !== this.state.category || !this.state.hasChosen;

      this.#categoryButtons().forEach((b) => b.setAttribute('aria-pressed', 'false'));
      button.setAttribute('aria-pressed', 'true');

      this.state.category = value;
      this.state.hasChosen = true;

      this.#updateBrandOptions();
      this.#render();

      if (changed && this.grid) {
        this.grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    #toggleBudget(button) {
      const group = this.#budgetButtons();
      const wasActive = button.getAttribute('aria-pressed') === 'true';

      group.forEach((b) => b.setAttribute('aria-pressed', 'false'));

      if (wasActive) {
        this.state.min = null;
        this.state.max = null;
      } else {
        button.setAttribute('aria-pressed', 'true');
        const min = button.getAttribute('data-min');
        const max = button.getAttribute('data-max');
        this.state.min = min !== '' && min != null ? Number(min) : null;
        this.state.max = max !== '' && max != null ? Number(max) : null;
      }

      this.state.hasChosen = true;
      this.#render();
    }

    #reset() {
      this.state = { category: '', min: null, max: null, search: '', brand: '', hasChosen: false };
      this.#categoryButtons().forEach((b) => b.setAttribute('aria-pressed', 'false'));
      this.#budgetButtons().forEach((b) => b.setAttribute('aria-pressed', 'false'));
      if (this.searchInput) this.searchInput.value = '';
      this.#updateBrandOptions();
      this.#render();
    }

    #applyFromURL() {
      const params = new URLSearchParams(window.location.search);
      const cat = (params.get('gave') || '').toLowerCase();
      const min = params.get('min');
      const max = params.get('max');

      if (params.has('gave') || min !== null || max !== null) {
        this.state.hasChosen = true;
      }

      if (params.has('gave')) {
        const button = this.#categoryButtons().find(
          (b) => (b.getAttribute('data-value') || '').toLowerCase() === cat
        );
        if (button) button.setAttribute('aria-pressed', 'true');
        this.state.category = cat;
      }

      if (min !== null || max !== null) {
        const minValue = min !== null ? Number(min) : null;
        const maxValue = max !== null ? Number(max) : null;
        this.state.min = minValue;
        this.state.max = maxValue;

        const button = this.#budgetButtons().find((b) => {
          const bMin = b.getAttribute('data-min');
          const bMax = b.getAttribute('data-max');
          return (
            (bMin !== '' ? Number(bMin) : null) === minValue &&
            (bMax !== '' ? Number(bMax) : null) === maxValue
          );
        });
        if (button) button.setAttribute('aria-pressed', 'true');
      }
    }

    #updateURL() {
      const url = new URL(window.location.href);
      url.search = '';
      if (this.state.category) url.searchParams.set('gave', this.state.category);
      if (this.state.min !== null) url.searchParams.set('min', String(this.state.min));
      if (this.state.max !== null) url.searchParams.set('max', String(this.state.max));
      history.replaceState(history.state, '', url.pathname + url.search);
    }

    // "Kun brands innenfor angitte kategori vises" - rebuilds the dropdown's
    // options from scratch on every category change, scoped to category
    // only (not price/søk/merke), per spec.
    #updateBrandOptions() {
      if (!this.brandSelect) return;

      const { category } = this.state;
      const brands = new Set();

      this.#tiles().forEach((tile) => {
        if (category) {
          const cats = (tile.getAttribute('data-mm-gift-cats') || '').toLowerCase().split(' ');
          if (!cats.includes('gift:' + category)) return;
        }
        const brand = tile.getAttribute('data-mm-brand');
        if (brand) brands.add(brand);
      });

      const sorted = Array.from(brands).sort((a, b) => a.localeCompare(b, 'no'));
      const previousValue = this.state.brand;

      this.brandSelect.innerHTML = '';
      const allOption = document.createElement('option');
      allOption.value = '';
      allOption.textContent = 'Alle merker';
      this.brandSelect.appendChild(allOption);

      sorted.forEach((brand) => {
        const option = document.createElement('option');
        option.value = brand;
        option.textContent = brand;
        this.brandSelect.appendChild(option);
      });

      // A brand that no longer exists in the newly selected category can't
      // stay selected - reset it rather than silently filtering to nothing.
      if (previousValue && !sorted.includes(previousValue)) {
        this.state.brand = '';
      }
      this.brandSelect.value = this.state.brand;
    }

    #render() {
      if (!this.grid) return;

      if (!this.state.hasChosen) {
        this.#tiles().forEach((tile) => { tile.hidden = true; });
        if (this.prompt) this.prompt.hidden = false;
        if (this.empty) this.empty.hidden = true;
        if (this.countEl) this.countEl.textContent = '';
        if (this.resetButton) this.resetButton.hidden = true;
        this.#updateURL();
        return;
      }

      if (this.prompt) this.prompt.hidden = true;

      const { category, min, max, search, brand } = this.state;
      const tiles = this.#tiles();
      let visibleCount = 0;

      tiles.forEach((tile) => {
        let visible = true;

        if (category) {
          const cats = (tile.getAttribute('data-mm-gift-cats') || '').toLowerCase().split(' ');
          visible = visible && cats.includes('gift:' + category);
        }

        const price = Number(tile.getAttribute('data-mm-price') || '0');
        if (min !== null) visible = visible && price >= min;
        if (max !== null) visible = visible && price <= max;

        if (search) {
          const titleText = tile.getAttribute('data-mm-title') || '';
          visible = visible && titleText.includes(search);
        }

        if (brand) {
          visible = visible && tile.getAttribute('data-mm-brand') === brand;
        }

        tile.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      if (this.empty) this.empty.hidden = visibleCount > 0;

      if (this.countEl) {
        this.countEl.textContent =
          visibleCount === tiles.length
            ? `${tiles.length} gaver`
            : `Viser ${visibleCount} av ${tiles.length} gaver`;
      }

      const hasActiveFilters = category || min !== null || max !== null || search || brand;
      if (this.resetButton) this.resetButton.hidden = !hasActiveFilters;

      this.#updateURL();
    }
  }

  if (!customElements.get('mm-christmas-filters')) {
    customElements.define('mm-christmas-filters', MerchMakerChristmasFilters);
  }

  } catch(e) { console.error(e); }
})();
})();
